import { Maximize2, X } from "lucide-react";
import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { useSplitView } from "@/hooks/use-split-view";

export function SplitViewPanel() {
  const { state, closeSplitView } = useSplitView();
  const [location, navigate] = useLocation();
  const prevLocationRef = useRef(location);

  // Close split view on route change
  useEffect(() => {
    if (prevLocationRef.current !== location && state) {
      closeSplitView();
    }
    prevLocationRef.current = location;
  }, [location, state, closeSplitView]);

  // ESC to close (only if no dialog is open)
  useEffect(() => {
    if (!state) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      // biome-ignore lint/security/noSecrets: CSS selector, not a secret
      if (e.key === "Escape" && !document.querySelector("[role='dialog']")) {
        closeSplitView();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [state, closeSplitView]);

  return (
    <div
      className={`border-l border-border flex flex-col overflow-hidden transition-[width] duration-300 ${
        state ? "w-[480px]" : "w-0"
      }`}
    >
      {state && (
        <>
          <div className="flex items-center justify-between px-4 py-2 border-b border-border bg-muted/30 flex-shrink-0">
            <span className="text-sm font-medium truncate">{state.title}</span>
            <div className="flex items-center gap-1">
              {state.openAsPageUrl && (
                <Button
                  size="sm"
                  variant="ghost"
                  className="h-7 w-7 p-0"
                  title="Abrir como página"
                  onClick={() => {
                    navigate(state.openAsPageUrl!);
                    closeSplitView();
                  }}
                >
                  <Maximize2 className="h-3.5 w-3.5" />
                </Button>
              )}
              <Button
                size="sm"
                variant="ghost"
                className="h-7 w-7 p-0"
                title="Fechar"
                onClick={closeSplitView}
              >
                <X className="h-3.5 w-3.5" />
              </Button>
            </div>
          </div>
          <div className="flex-1 overflow-y-auto p-4">{state.body}</div>
        </>
      )}
    </div>
  );
}
